import React, { useEffect } from 'react';
import * as S from './Styled';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  fullScreen?: boolean;
  noPadding?: boolean;
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  fullScreen = false,
  noPadding = false
}) => {
  // Bloquear scroll do body quando modal abrir
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  // Fechar com ESC
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <S.Backdrop $isOpen={isOpen} onClick={onClose}>
      <S.Content $fullScreen={fullScreen} onClick={e => e.stopPropagation()}>
        {title && (
          <S.Header>
            <S.Title>{title}</S.Title>
            <S.CloseButton onClick={onClose}>&times;</S.CloseButton>
          </S.Header>
        )}
        <S.Body $noPadding={noPadding}>{children}</S.Body>
        {footer && <S.Footer>{footer}</S.Footer>}
      </S.Content>
    </S.Backdrop>
  );
};
